import { useQuery } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'
import { PaginationMetadata, PaginationParams } from '../../../types/pagination'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { AccountId } from '../models'

export type GoogleAdAccountResponse = {
  adAccounts: AccountId[]
  metadata?: PaginationMetadata
  selected?: number[]
}

export const getGoogleAccounts = (
  accountId: number | string | undefined,
  connectionId: number | undefined,
  pagination?: PaginationParams
): Promise<GoogleAdAccountResponse | Error> => {
  if (!accountId || !connectionId) throw new Error('Account id is not defined')
  return request<{ adAccounts: AccountId[] }>({
    url: `/accounts/${accountId}/google/${connectionId}/ad-accounts`,
    method: 'GET',
    params: pagination,
  })
}

type QueryFnType = typeof getGoogleAccounts

export const useGetGoogleAccounts = ({
  connectionId,
  config,
  pagination,
}: {
  connectionId: number | undefined
  config?: QueryConfig<QueryFnType>
  pagination?: PaginationParams
}) => {
  const { accountId } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [
      'googleAdAccounts',
      connectionId,
      pagination?.page,
      pagination?.limit,
      pagination?.search,
      pagination?.sort,
    ],
    queryFn: () => getGoogleAccounts(`${accountId}`, connectionId, pagination),
    enabled: !!connectionId,
    ...config,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data

  return { ...query, data }
}
